import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getHeaders } from '../../lib/requests';

const CustomerModal = ({ isOpen, setIsOpen, selectCustomer, value, client, disabled }) => {
    const [customers, setCustomers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedCustomer, setSelectedCustomer] = useState({ customer_id: '', first_name: '', last_name: '' });

    useEffect(() => {
        if (value && !isOpen) {
            setSelectedCustomer(value);
        }

        if (!isOpen) return;

        fetchCustomers();
    }, [isOpen, searchQuery, value]);

    const fetchCustomers = async () => {
        setIsLoading(true);
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const apiToken = localStorage.getItem('accessToken');
            const params = searchQuery ? { search: searchQuery } : {};

            if (client !== undefined) {
                params.client_id = client.client_id;
            }

            const response = await axios.get(`${apiUrl}/customers`, {
                headers: getHeaders(apiToken),
                params,
            });
            setCustomers(response.data.data);
        } catch (error) {
            console.error('Error fetching customers', error);
        } finally {
            setIsLoading(false);
        }
    };

    const toggleModal = () => {
        if (disabled) {
            return;
        }
        setIsOpen(!isOpen);
    };

    const handleSelectCustomer = (customer) => {
        if (disabled) return;
        selectCustomer(customer); // Assuming `selectCustomer` is handling necessary state updates elsewhere
        setSelectedCustomer(customer); // Update local state with selected customer
        setIsOpen(false); // Close the modal after selection
    };

    return (
        <>
            <div className="flex items-end space-x-4">
                <div className="flex-1">
                    <label htmlFor="customer_id" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Client Selected</label>
                    <input
                        type="text"
                        id="customer_id"
                        name="customer_id"
                        value={selectedCustomer ? `${selectedCustomer.first_name} ${selectedCustomer.last_name}` : ''}
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Customer"
                        readOnly
                        {...disabled && { disabled: true }}
                    />
                </div>
                <div>
                    <button
                        onClick={toggleModal}
                        disabled={disabled}
                        className={`text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center 
                            ${disabled ? 'bg-gray-400 hover:bg-gray-400 cursor-not-allowed' : 'dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800'}`}>
                        Select Customer
                    </button>

                </div>
            </div>


            {isOpen && (
                <>
                    <div className="fixed inset-0 bg-black bg-opacity-35 z-50"></div>

                    <div id="crud-modal" className="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 flex justify-center items-center w-full h-[calc(100%-1rem)] max-h-full">
                        <div className="relative p-4 w-full max-w-md h-full md:h-auto">
                            <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                                <div className="flex justify-between items-start p-4 rounded-t border-b dark:border-gray-600">
                                    <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                                        Select a Customer from {client ? client.name : 'All Clients'}
                                    </h3>
                                    <button type="button" className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white" onClick={toggleModal}>
                                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                        </svg>
                                    </button>
                                </div>
                                <div className="p-4">
                                    <input
                                        type="text"
                                        placeholder="Search customers..."
                                        className="mb-4 pl-4 pr-4 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                    {isLoading ? (
                                        <p>Loading customers...</p>
                                    ) : (
                                        <ul className="max-h-60 overflow-y-auto">
                                            {customers.map((customer) => (
                                                <li
                                                    key={customer.id}
                                                    className="cursor-pointer hover:bg-gray-100 p-2"
                                                    onClick={() => handleSelectCustomer(customer)}
                                                >
                                                    {customer.first_name} {customer.last_name}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                                <div className="flex items-center p-6 space-x-2 rounded-b border-t border-gray-200 dark:border-gray-600">
                                    <button onClick={toggleModal} className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </>
            )}
        </>
    );
};

export default CustomerModal;

